module.exports = __webpack_public_path__ + "img/CASH.1eba8f71.svg";